import {Dispatch, SetStateAction} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';

interface IProps {
  shouldOpen: boolean;
  setShouldOpen: Dispatch<SetStateAction<boolean>>;
}

const OrderAdminPendingSheet = ({shouldOpen, setShouldOpen}: IProps) => {
  return (
    <BottomSheet
      onDismiss={() => {
        setShouldOpen(false);
      }}
      open={shouldOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-6 left-6"
          onClick={() => setShouldOpen(false)}
        />

        <p className="flex justify-center w-full p-0 m-0 mt-2 text-sm font-medium text-zinc-500">
          بررسی فیش پرداخت
        </p>

        <div className="flex flex-col justify-between w-full gap-3">
          <div className="w-full px-0 py-4 m-0 text-sm text-right text-neutral-500 font-Regular">
            تصویر فیش پرداخت شما بارگذاری شده و توسط کارشناسان ما در حال بررسی
            است. نتیجه از طریق پیامک اطلاع داده می‌شود.
          </div>

          <div className="flex items-center gap-2">
            <Button
              className="w-full"
              onClick={() => {
                setShouldOpen(false);
              }}
            >
              متوجه شدم
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default OrderAdminPendingSheet;
